import {BaseVictoryPointData} from './BaseVictoryPointData'
import {TranslationKeys} from '@colonist/i18n'
import {VictoryPointType} from '@colonist/game-states'

/**
 * @deprecated use `packages/game-states`'s VictoryPointType instead
 */
export import VictoryPointTypes = VictoryPointType

export class VictoryPointDataSettlement extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Settlement
    value = 1
    private = false
    endGameImageFileName = 'settlement_mysticblue'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.settlementVps'
}

export class VictoryPointDataCity extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.City
    value = 2
    private = false
    endGameImageFileName = 'city_mysticblue'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.cityVps'
}

export class VictoryPointDataDevelopmentCard extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.DevelopmentCardVictoryPoint
    value = 1
    private = true
    endGameImageFileName = 'stat_vp'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.devCardVps'
}

export class VictoryPointDataLargestArmy extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.LargestArmy
    value = 2
    private = false
    endGameImageFileName = 'stat_largest_army'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.largestArmy'
}

export class VictoryPointDataLongestRoad extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.LongestRoad
    value = 2
    private = false
    endGameImageFileName = 'stat_longest_road'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.longestRoad'
}

export class VictoryPointDataChit extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Chits
    value = 1
    private = false
    endGameImageFileName = 'stat_chits'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.chitVps'
}

export class VictoryPointDataMetropolis extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Metropolis
    value = 2
    private = false
    endGameImageFileName = 'stat_metropolis'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.metropolis'
}

export class VictoryPointDataDefenderOfColonist extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.DefenderOfColonist
    value = 1
    private = false
    endGameImageFileName = 'stat_defender'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.defenderOfColonist'
}

export class VictoryPointDataProgressCard extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.ProgressCardVictoryPoint
    value = 1
    private = false
    endGameImageFileName = 'stat_vp'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.devCardVps'
}

export class VictoryPointDataMerchant extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Merchant
    value = 1
    private = false
    endGameImageFileName = 'stat_merchant'
    endGameToolTipKey: TranslationKeys = 'strings:game.endGame.overview.merchant'
}
